import type { ICONS } from './icons';
import { Container } from '@acies/core';
import Icon from './icon';
import Label from './label';

export default class IconTitle extends Container {
	public set icon(value: keyof typeof ICONS | null) {
		this.#iconChild.name = value;
	}

	public get icon(): keyof typeof ICONS | null {
		return this.#iconChild.name;
	}

	public set text(value: string) {
		this.#labelChild.text = value;
	}

	public get text(): string {
		return this.#labelChild.text;
	}

	#iconChild: Icon;
	#labelChild: Label;

	public constructor(icon: keyof typeof ICONS | null = null, text = '') {
		super();
		this.alignment = 'left';
		this.gapHorizontal = 8;
		this.#iconChild = new Icon(icon);
		this.#labelChild = new Label();
		this.#labelChild.size = 'large';
		this.#labelChild.text = text;
		this.#labelChild.variant = 'dark';
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.#iconChild, this.#labelChild]);
	}
}
customElements.define('ac-icon-title', IconTitle);
